import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Popover } from '@mui/material';
import MapsUgcIcon from '@mui/icons-material/MapsUgc';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import EmojiPicker from './EmojiPicker';

const TextInputFeatures = ({ onTemplateSelect, textareaRef }) => {
  const [emojiAnchorEl, setEmojiAnchorEl] = useState(null);

  const handleEmojiClick = event => {
    setEmojiAnchorEl(event.currentTarget);
  };

  const handleEmojiClose = () => {
    setEmojiAnchorEl(null);
  };

  const handleEmojiSelect = emoji => {
    if (textareaRef?.current) {
      const textarea = textareaRef.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const newText = text.substring(0, start) + emoji + text.substring(end);
      textarea.value = newText;

      // Set cursor position after the inserted emoji
      textarea.selectionStart = textarea.selectionEnd = start + emoji.length;

      // Trigger input event to update React state
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
    }
    handleEmojiClose();
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Tooltip title='Textvorlage auswählen'>
        <IconButton onClick={onTemplateSelect}>
          <MapsUgcIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title='Emoji'>
        <IconButton size='small' onClick={handleEmojiClick}>
          <EmojiEmotionsIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(emojiAnchorEl)}
        anchorEl={emojiAnchorEl}
        onClose={handleEmojiClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <EmojiPicker onEmojiSelect={handleEmojiSelect} />
      </Popover>
    </Box>
  );
};

export default TextInputFeatures;
